import { render } from "./JumbotronBox.vue?vue&type=template&id=370517fe&scoped=true"
import script from "./JumbotronBox.vue?vue&type=script&lang=js"
export * from "./JumbotronBox.vue?vue&type=script&lang=js"

import "./JumbotronBox.vue?vue&type=style&index=0&id=370517fe&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370517fe"]])

export default __exports__